export default __webpack_public_path__ + "static/media/myprofile.fc9f3790.png";